<template>
  <v-navigation-drawer v-model="$root.navigation" class="drawer" mobile-breakpoint="768" app>
    <div class="drawer--title text-center" style="position: relative">
      <router-link class="logo-link" active-class="active" :exact="true" :to="{ name: 'APDashBoard' }">
        <img src="../../assets/logo.png" alt="Logo" class="logo" />
        <div style="
            font-size: 10px;
            position: absolute;
            top: 24px;
            right: 8px;
            display: inline;
            color: #b0abab;
            font-weight: bold;
          ">
          Version: 2.0.0
        </div>
      </router-link>
      <!-- <span>Q</span>
      <span>S</span>Learning-->
    
    </div>
    <div class="drawer--nav mt-2">
      <drawer-item v-for="(link, index) in links" :key="index" :link="link" :active="link.active" />
    </div>
    <div class="nav-bg"></div>
  </v-navigation-drawer>
  
</template>

<script>
import DrawerItem from "./DrawerItem.vue";

export default {
  name: "Drawer",
  components: {
    DrawerItem,
  },
  data() {
    return {
      admin: [],
      student: [],
      tutor: [],
      links: this.$store.getters.userLinks,
    };
  },
  watch:{
    
  },
  methods: {
    filterRoleWiseLinks() {
      let routes = this.$store?.getters?.userLinks;
      console.log(routes.length,'routes.length');
      if (routes.length > 0) {

        // filter admin routes
        let adminRoutes = routes.filter((link) => {
          return link.flag === 'admin'
        })
        this.admin = adminRoutes;
        console.log(adminRoutes, 'adminRoutes');

        // filter student routes
        let studentRoutes = routes.filter((link) => {
          return link.flag === 'student'
        })
        this.student = studentRoutes;
        console.log(studentRoutes, 'studentRoutes');

        // filter tutor routes
        let tutorRoutes = routes.filter((link) => {
          return link.flag === 'tutor'
        })
        this.tutor = tutorRoutes;
        console.log(tutorRoutes, 'tutorRoutes');
      }
    }
  },
  mounted() {
    this.filterRoleWiseLinks();
  },
};
</script>

<style lang="scss">
.link--heading {
  z-index: 999;
  font-size: 16px;
  background-color: white;
  border-radius: 11px;
  padding: 5px 5px 5px 16px;
  margin: 12px 17px -25px 17px;
  text-transform: capitalize;
  color: #6d3f8e;
  font-weight: 500;
}

.drawer {
  overflow: visible !important;

  & .nav-bg {
    background-image: url("../../assets/nav-bg.png");
    background-repeat: no-repeat;
    min-height: 200px;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0px;
    background-size: auto;
  }

  &--title {
    color: rgb(107, 22, 143);
    font-size: large;
    background: #ffffff;
    height: 64px;
    line-height: 64px;

    & span {
      background: rgb(107, 22, 143);
      color: white;
      padding: 5px;
      margin-right: 3px;
    }
  }

  & .v-navigation-drawer__content {
    display: flex;
    background: #2e3032;
    flex-direction: column;
  }

  &--nav {
    flex-grow: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-auto-rows: 100px;
    padding-top: 30px;
    margin: 0 auto;
    position: relative;
    z-index: 9;
  }

  @media only screen and (max-width: 900px) {
    &--title {
      color: rgb(107, 22, 143);
      font-size: 1.5rem;
      font-weight: 900;
      height: 56px;
      line-height: 56px;
    }
  }
}
</style>
